<template>
  <vs-dropdown-item class="text-base py-2"
                    @click="$emit('click')"
                    @mouseover="isHover = true"
                    @mouseleave="isHover = false">
    <div class="flex items-center"
        :class="isHover ? 'text-primary-focus' : 'text-gray-dark'">
      <slot name="icon" :isHover="isHover" />
      <span class="ml-3" :class="[{ 'text-primary-focus': isHover }, labelClasses]">
        {{ label }}
      </span>
    </div>
  </vs-dropdown-item>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    label: {
      type: String,
      required: true
    },
    labelClasses: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHover: false
    }
  }
}
</script>
